const PERSONALIZE_EDGE_API_URL = 'https://personalize-edge.contentstack.com';

export function getExperienceAndVariantFromAlias(alias) {
  // alias format: cs_personalize_[experience_short_uid]_[active_variant] - cs_personalize_0_1
  const parts = alias.split('_');
  return { experienceShortUid: parts[2], variantShortUid: parts[3] };
}

/**
 Replacement for sdk.triggerEvent which doesn't have keepalive option, and requests are being cancelled on page unload
 * @param eventName
 * @param sdk
 * @returns {Promise<Response|void>}
 */
export async function triggerEvent(eventName, sdk) {
  if (!sdk) return;
  const payload = JSON.stringify([
    {
      eventKey: eventName,
      type: 'EVENT',
    },
  ]);
  return fetch(`${PERSONALIZE_EDGE_API_URL}/events`, {
    method: 'POST',
    keepalive: true,
    headers: {
      'X-Project-Uid': process.env.CONTENTSTACK_PERSONALIZE_UID,
      'X-CS-Personalize-User-Uid': sdk.getUserId(),
      'X-User-Agent': 'personalize-edge-sdk-js/1.0.21',
      'Content-Type': 'application/json',
    },
    body: payload,
  });
}
